/**
 * Wraps a {@link SolanaRequestFn} into a {@link SolanaWalletProvider}.
 *
 * This helper does not use any `@solana/web3.js` runtime values, so it is safe
 * to import from the package root without `@solana/web3.js` installed.
 */
export const createSolanaWalletProvider = (request) => ({
    request,
    signMessage: (msg) => request({ method: 'signMessage', params: { message: msg } }),
    signTransaction: (transaction) => request({ method: 'signTransaction', params: { transaction } }),
    signAndSendTransaction: (input) => request({
        method: 'signAndSendTransaction',
        params: input,
    }),
});
